import router from '../../router'
import Message_TemplateService from '../../services/WhatsAppService'

const state = () => ({
    loadingMessage_Templates: false,
    message_template: null,
    message_templates: (() => {
        try {
            return {
                timestamp: localStorage.getItem('message_templates') ? JSON.parse(localStorage.getItem('message_templates')).timestamp : null,
                data: localStorage.getItem('message_templates') ? JSON.parse(localStorage.getItem('message_templates')).data : [],
            }
        } catch (error) {
            localStorage.removeItem('message_templates');
            return [];
        }
    })(),
    total: 0,
    pages: 0,
    page: 1,
    show_modal_new_message_template: false
})
  
const mutations = {
    SET_MESSAGE_TEMPLATES: (state, payload) => {
        if(payload.pageNumber == 1) {
            state.message_templates.data = payload.itens
        }else{
            state.message_templates.data = [...state.message_templates.data, ...payload.itens]
        }
        state.message_templates.timestamp = new Date().getTime() + (1 * 24 * 60 * 60 * 1000); // (24 horas * 60 minutos * 60 segundos * 1000 milissegundos) ao timestamp
        localStorage.setItem('message_templates', JSON.stringify(state.message_templates));
        state.page =  payload.pageNumber
        state.pages =  payload.pages
        state.total =  payload.total

    },
    SET_LOADING_MESSAGE_TEMPLATES: (state, payload) => {
        state.loadingMessage_Template = payload
    },
}

const actions = {
    async fetchMessage_Templates({commit}, params = {}){
        try{
            commit('SET_LOADING_MESSAGE_TEMPLATES', true)
            const { keyword = '', pageNumber = 1, pageSize = 12, order = { name: 'ID', column: 'ID', sort: 'ASC' } } = params;
            const response = await Message_TemplateService.get(keyword, pageNumber, pageSize, order);
            commit('SET_MESSAGE_TEMPLATES', response.data)
            commit('SET_LOADING_MESSAGE_TEMPLATES', false)
        } catch (error) {
            commit('SET_LOADING_MESSAGE_TEMPLATES', false);
            if(error && error.response && error.response.data.message == "Sessão expirada") {
                commit('SET_REDIRECT', router.currentRoute.value.path);
            }
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
}

const getters = {
    getMessage_Templates: state => {
        const isExpired = state.message_templates.timestamp && state.message_templates.timestamp < new Date().getTime();
        return isExpired || !state.message_templates.data ? [] : state.message_templates.data;
    },
    getLoadingMessage_Template: state => state.loadingMessage_Template,
}

export default {
    state,
    getters,
    mutations,
    actions
};